<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-title>
            <h2>Permisos</h2>
          </v-card-title>
          <v-card-text>
            <DataTableMain
              :datatable="table"
              :on-success="successAction"
              :itemsAction="tableAction"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <PermisosDialog v-if="get_dialogMain.dialog" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import PermisosDialog from '@/components/dialogs/PermisosDialog'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          {
            title: 'Refrescar',
            icon: 'mdi-cached',
            color: 'primary',
            action: 'refreshData',
            code: 'libre',
            hidden: ''
          },
          {
            title: 'Nuevo',
            icon: 'mdi-plus',
            color: 'success',
            action: 'newData',
            code: '0203-01'
          }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Slug', value: 'slug', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain,
    PermisosDialog
  },
  mounted () {
    // this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
    this.getPermisos()
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getPermisos()
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.table.header.options.map(action => {
            action.hidden = ''
          })
          this.table.body.actions.map(action => {
            action.hidden = ''
          })
        } else {
          this.table.header.options.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
          this.table.body.actions.map(action => {
            permisos.permisos.map(item => {
              if (action.code !== 'libre') {
                if (action.code === item.slug) {
                  action.hidden = ''
                }
              }
            })
          })
        }
      } else {
        this.table.header.options.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
        this.table.body.actions.map(action => {
          permisos.permisos.map(item => {
            if (action.code !== 'libre') {
              if (action.code === item.slug) {
                action.hidden = ''
              }
            }
          })
        })
      }
    },
    ...mapActions(['getPermisos']),
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_permisos'])
  },
  watch: {
    get_permisos (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style></style>
